__turbopack_context__.v({
  "className": "la_belle_aurore_9ea5c85d-module__QmHnGG__className",
});
